<script>
import { mapActions } from 'vuex'
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";

import moment from 'moment';
import DatePicker from "vue2-datepicker";
import * as XLSX from 'xlsx';

export default {
  page: {
    title: "Export Last Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker
  },
  data() {
    return {
      tableData: [],
      title: "Export Last Login",
      items: [
        {
          text: "Export Data",
          href: "/report/lastlogin",
        },
        {
          text: "Last Login",
          active: true,
        },
      ],
      exportData: [],
      daterange: [new Date(), new Date()],
      form: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      showbtn: true,
      formError: '',
      isFormError: false,
    };
  },
  watch: {
    isFormError: {
      handler: function (val, oldVal) {
        if (!val) {
          this.formError = '';
        }
      }
    },
  },
  mounted() {
  },
  created() {
    this.getAccess();
  },
  methods: {
    ...mapActions('reports', ['lastLogin']),
    getAccess() {
      let userdata = JSON.parse(localStorage.getItem('user'));
      if (userdata.userdata.role.name != 'superadmin') { this.$router.push({ name: 'error-404' }); }
    },
    exportLogin() {
      let userdata = JSON.parse(localStorage.getItem('user'));
      if (userdata.userdata.role.name != 'superadmin') { this.$router.push({ name: 'error-500' }); }
      else {
        this.showbtn = false;
        this.exportData = [];
        this.form.startDate = moment(this.daterange[0]).format('YYYY-MM-DD');
        this.form.endDate = moment(this.daterange[1]).format('YYYY-MM-DD');
        this.lastLogin(this.form).then((response) => {
            this.exportData = response.data.length > 0 ? response.data : [];
            const data = XLSX.utils.json_to_sheet(this.exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, 'Last Login');
            XLSX.writeFile(wb, `last-login_${this.form.startDate}-${this.form.endDate}.xlsx`);
            this.isFormError = false;
            this.showbtn = true;
        }).catch((error) => {
            this.formError = error;
            this.isFormError = true;
            this.showbtn = true;
        })
      }
    },
    
  },
  middleware: "router-auth",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              variant="danger"
              class="mt-3"
              v-model="isFormError"
              :show="5"
              dismissible
              >{{ formError }}</b-alert
            >
            <div>
                <div class="form-group mb-3">
                    <label>Date Range</label><br />
                    <date-picker :format="'DD/MM/YYYY'" v-model="daterange" range append-to-body lang="id" confirm></date-picker>
                </div>
            </div>
            <button type="button" class="btn btn-primary" v-on:click="exportLogin()" :disabled="!showbtn">Export</button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
